/**
 * Standard employment type options for create/edit (mock parity: W2 / 1099 / CIM).
 * Legacy DB values (full_time, etc.) are handled by employmentTypeHelper for display/edit only.
 */
export const EMPLOYMENT_TYPE_OPTIONS = [
  { label: 'W2', value: 'W2' },
  { label: '1099', value: '1099' },
  { label: 'CIM', value: 'CIM' }
];

/**
 * Companies keyed by employment type affiliation (mock parity).
 * Prefer getCompanyOptionsForEmploymentType() over duplicating lists.
 */
export const COMPANY_OPTIONS = [
  {
    label: 'CRC Transport LLC',
    value: 'CRC Transport LLC',
    employmentTypes: ['W2', '1099']
  },
  {
    label: 'CRC Auto Group',
    value: 'CRC Auto Group',
    employmentTypes: ['W2', '1099']
  },
  {
    label: 'Fox Solution',
    value: 'Fox Solution',
    employmentTypes: ['CIM']
  },
  {
    label: 'FoxExpress',
    value: 'FoxExpress',
    employmentTypes: ['CIM']
  },
  {
    label: 'Fox Logistic',
    value: 'Fox Logistic',
    employmentTypes: ['CIM']
  },
  {
    label: 'Fox Soft Invest',
    value: 'Fox Soft Invest',
    employmentTypes: ['CIM']
  }
];

/**
 * @param {string|null|undefined} type
 * @returns {Array<{label: string, value: string}>}
 */
export function getCompanyOptionsForEmploymentType(type) {
  const t = String(type || '').trim();
  if (!t) return [];
  return COMPANY_OPTIONS.filter((company) =>
    (company.employmentTypes || []).includes(t)
  ).map(({ label, value }) => ({ label, value }));
}
